import * as Yup from "yup";

export const SelfAccountTransferScehma = Yup.object().shape({
  account_source: Yup.string().required("Select Billing account"),
  beneficiary_account_no: Yup.string().required("Select destination account"),
  beneficiary_account_name: Yup.string().required("Enter valid account number to proceed"),
  amount: Yup.string().required("Enter transfer amount"),
  // narration: Yup.string().required("Enter a brief narration"),
});
